function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React from "react";
import { usePopperTooltip } from "react-popper-tooltip";
import "react-popper-tooltip/dist/styles.css";
var Tooltip = function(_param) {
    var children = _param.children, tooltip = _param.tooltip, options = _param.options, rest = _objectWithoutProperties(_param, [
        "children",
        "tooltip",
        "options"
    ]);
    var ref = usePopperTooltip(_objectSpread({
        placement: "bottom-end"
    }, options || {})), getArrowProps = ref.getArrowProps, getTooltipProps = ref.getTooltipProps, setTooltipRef = ref.setTooltipRef, setTriggerRef = ref.setTriggerRef, visible = ref.visible;
    return /*#__PURE__*/ React.createElement("div", _extends({
        ref: tooltip ? setTriggerRef : null
    }, rest), children, visible && tooltip && /*#__PURE__*/ React.createElement("div", _extends({
        ref: setTooltipRef
    }, getTooltipProps({
        className: "tooltip-container"
    })), tooltip, /*#__PURE__*/ React.createElement("div", _extends({}, getArrowProps({
        className: "tooltip-arrow"
    })))));
};
export default Tooltip;
